import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Truncate } from '.'

export default function Alert({ open, setOpen, resolutionsUnsaved }) {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Attention !!'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div style={{ color: 'black' }}>
            Vous n'avez pas enregistré les données que vous avez modifiés aux
            résolutions suivantes:
          </div>
          <ul style={{ fontSize: 13 }}>
            {resolutionsUnsaved.map((item) => {
              return (
                <li>
                  {item.numero}. {Truncate(item.libelle)}
                </li>
              )
            })}
          </ul>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}
